import axios, { AxiosResponse } from 'axios'
import qs from 'qs'
import { publish } from '../utils/globals'
import { ContentType } from '../preact-components/utils/contentType'

export async function getSpamContent ({ page, pageSize }: Pagination = { page: 1, pageSize: 25 }) {
  const response: AxiosResponse = await axios.get(
    `/community/api/spamContent${qs.stringify({ page, pageSize }, { addQueryPrefix: true }) as string}`
  )
  if (response.data) {
    const { result, _metadata: { totalCount: total } } = response.data
    response.data = { result, total }
    return response
  }

  return response
}

export async function getSpamContentCount () {
  return await axios.get('/community/api/spamContent/count')
}

export async function markPostsAsSpam (posts: Object[]) {
  await axios.post('/community/api/bulk/process', {
    action: 'markAsSpam',
    topics: posts
  })

  await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
  publish('posts_marked_as_spam', {})
}

export async function markPostsAsNotSpam (posts: Object[]) {
  await axios.post('/community/api/bulk/process', {
    action: 'markAsNotSpam',
    topics: posts
  })

  await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
  publish('posts_marked_as_not_spam', {})
}

export async function isSpam (id: number, contentType: ContentType, isReply: boolean) {
  return await axios.post('/community/api/spamContent/isSpam', {
    id, contentType, isReply
  })
}

export async function permanentlyDeleteSpamPosts (posts: Object[]) {
  await axios.post('/community/api/bulk/process', {
    action: 'permanentlyDelete',
    topics: posts
  })

  await axios.post('/community/api/invalidateCache?apiPath=spamContent/count')
  publish('posts_permanently_deleted_spam', {})
}
